import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import SummaryUser from "./user/summaryTimeAndSalary";
import SummaryAdminVendor from "./vendor/summaryTime";
import AdminPage from "./admin/homepage";

import HomePageVendor from "./vendor/homepage";

import ManagerPage from "./manager/homepage";

import Backdrop from "./shared/general/Backdrop";

const SummaryOTShiftPage = () => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const { result: userProfile } = useSelector((state) => state.userProfile);

  const render = () => {
    if (currentUser.roles.includes("ROLE_USER")) {
      return <SummaryUser />;
    } else if (currentUser.roles.includes("ROLE_ADMIN")) {
      //return <AdminPage />;
    } else if (currentUser.roles.includes("ROLE_VENDOR")) {
      return <SummaryAdminVendor />;
    } else if (currentUser.roles.includes("ROLE_MANAGER")) {
      //return <ManagerPage />;
    }
  };

  return (
    <div>
      {currentUser && userProfile ? (
        <Fragment>{render()}</Fragment>
      ) : (
        <Fragment>
          <Backdrop open={!(currentUser && userProfile)} />
        </Fragment>
      )}
    </div>
  );
};

export default SummaryOTShiftPage;
